import { Props } from './types';
import { DialogActions as StyledDialogActions } from './DialogActions.styled';

export function DialogActions({ ...rest }: Props) {
  return <StyledDialogActions {...rest} />;
}
